/* Model Object which can be passed to Modal service which then can be used
   by Modal's child component
 */
export class ModalConfig<M = any> {
  data?: M;
}
